import {
  Carousel,
  Popover,
  Select,
  Input,
  Button,
  message,
  Modal,
  Spin,
} from "antd";
import React, { useEffect, useState } from "react";
import "./App.css";
import { ExclamationCircleOutlined } from "@ant-design/icons";

const { Option } = Select;

const DeleteAccountPage = () => {
  const [method, setMethod] = useState("email"); // 默认选择 email
  const [inputValue, setInputValue] = useState("");
  const [loading, setLoading] = useState(false);

  function handleConfirmDelete() {
    setLoading(true);
     const requestBody = {
    [method]: inputValue // 如果 method 是 "email"，则为 { email: "123" }
  };
    fetch("https://api.meboo-app.com/api/users/removeByEmail", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(requestBody)
    })
      .then(() => {
        message.success("Your account has beensuccessfully deleted");
      })
      .finally(() => {
        setLoading(false);
      });
  }

  const showDeleteConfirm = () => {
    Modal.confirm({
      title: "Confirm?",
      icon: <ExclamationCircleOutlined />,
      content: "",
      okText: "Ok",
      okType: "danger",
      cancelText: "Cancel",
      onOk() {
        handleConfirmDelete();
      },
      onCancel() {},
    });
  };

  return (
    <div className="page_body">
      {/* 返回按钮 */}
      <a href="/" target="_blank" className="back_button">
        Homepage
      </a>

      <div
        className="slogan"
        style={{
          position: "relative",
          flexDirection: "column",
          zIndex: 2,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div className="meboo"></div>
        <div className="ifyou">
          If you wish to delete your account and all related data, please follow
          these steps:
          <br />
          1. Verify your login email on meboo.
          <br />
          2. Enter your email.
          <br />
          3. click button "Confirm Account Deletion.
          <br />
          Note: Once the deletion is successful, your account will be
          deactivated, and all your data will be removed after 3 months.
        </div>
      </div>

      <div className="google_login">
        <Spin spinning={loading}>
          <div className="form_content">
            {/* 下拉框 */}
            <Select
              defaultValue="email"
              style={{ width: 200, marginBottom: 20 }}
              onChange={(value) => setMethod(value)}
            >
              <Option value="email">Email</Option>
              <Option value="mobile">Phone</Option>
            </Select>

            {/* 根据选择显示输入框 */}
            {method === "email" ? (
              <Input
                placeholder="Enter your email"
                value={inputValue}
                onChange={(e) => setInputValue(e.target.value)}
                style={{ marginBottom: 20 }}
              />
            ) : (
              <Input
                placeholder="Enter your phone number"
                value={inputValue}
                onChange={(e) => setInputValue(e.target.value)}
                style={{ marginBottom: 20 }}
              />
            )}

            {/* 删除按钮 */}
            <Button danger onClick={showDeleteConfirm} disabled={!inputValue}>
              Confirm Account Deletion
            </Button>
          </div>
        </Spin>
      </div>
    </div>
  );
};

export default DeleteAccountPage;
